export const BATCH_RECIPE_FETCH_SIZE = 12;
export const CACHE_TTL_SECONDS = 2678400; // cache API responses for 1 month
